import { Role, PrivilegedGroup } from "../types/role";

export const ROLE_VALUES: readonly Role[] = [
  Role.TenantAdmin,
  Role.Operator,
  Role.CostViewer,
  Role.DashboardViewer,
] as const;

export const PRIVILEGED_GROUP_VALUES: readonly PrivilegedGroup[] = [
  PrivilegedGroup.SfDiagnostic,
  PrivilegedGroup.GwDiagnostic,
] as const;
